module.exports = __webpack_public_path__ + "static/WeinTour_TV_Web_23-260e9ae74294e01913450a8ca4b17297.jpg";